<template>
  <div class="link_company_text">
    <a>
      <span class="logo">
        <SkeletonBox v-if="!logo" />
        <img v-else :src="thumbnailImageWithOptions(logo, {w: 52})" alt="">
        <span />
      </span>
      <span class="box">
        <span class="name font_h5"><slot name="companyName" /></span>
        <span class="text font_p3"><slot name="country" /><span><slot name="companySize" /></span></span>
        <span class="num font_h7">콘텐츠 <slot name="contentCnt" /> <span>팔로워 <slot name="followerCnt" /></span></span>
      </span>
    </a>
  </div>
</template>
<script setup lang="ts">
import { useImagesThumbnail } from '~/composables/images/thumbnail'

const { thumbnailImageWithOptions } = useImagesThumbnail()
defineProps({
  logo: {
    type: String
  }
})
</script>
<style scoped>
    .link_company_text{position:relative;}
    .link_company_text a{display: flex; gap: 8px; align-items: center; position:relative;}
    .link_company_text .logo{position:relative; display:inline-block; width:52px; height:52px; border-radius:100%; overflow:hidden; flex:none;}
    .link_company_text .logo span{display:inline-block; width:52px; height:52px; background:#fff; border:1px solid var(--color-line);  border-radius:100%; box-sizing:border-box;}
    .link_company_text .logo img{position: absolute; top: -100%; right: -100%; bottom: -100%; left: -100%; width: 100%; height: 100%; object-fit: cover; margin: auto;}
    .link_company_text .name{display:block; color:var(--color-text-title); letter-spacing:0;}
    .link_company_text .text{display:block; letter-spacing:0; margin-top:2px;}
    .link_company_text .text span:before{content:''; display:inline-block; vertical-align:3px; margin:0 5px 0 1px; width:2px; height:2px; background:var(--color-text-sub); border-radius:100%;}
    .link_company_text .num{display:none;}
    .link_company_text .num span{margin-left:8px;}
    .link_company_text.detail a{gap:24px;}
    .link_company_text.detail .num{display:block; margin-top:8px;}
    .link_company_text.detail .logo{width:78px; height:78px;}
    .link_company_text.detail .logo span{width:78px; height:78px;}
    .link_company_text.mypage .logo{width:52px; height:52px;}
    .link_company_text.mypage .text,
    .link_company_text.mypage .num{display:none;}
    .link_company_text.mypage_2{width:324px;}
    .link_company_text.mypage_2 .logo{width:52px; height:52px;}
    .link_company_text.mypage_2 .text,
    .link_company_text.mypage_2 .num{display:none;}
</style>
